<div class="flex">
    <div class="flex h-10 w-10 flex items-center justify-center overflow-hidden rounded-full mr-3">
        <img [alt]="userData.Username || ''" class="h-full w-full" [src]="profilePic">
    </div>
    <div class="font-semibold mt-3">
        {{userData.FirstName}} {{userData.LastName}}
    </div>
</div>